import { useContext } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import PsContext from "../../../context";
import { brandLogoWide, S3_BUCKET_HOME_PATH } from "../../../utils";

const Header = (props) => {
  const context = useContext(PsContext);

  const handleLogout = () => {
    if (!window.confirm("Do you want to logout?")) return;
    context.logout();
  };

  const firstPath = () => {
    try {
      let s = props.path.split("/");
      return s[1];
    } catch (er) {}
  };

  const getStep = () => {
    if (firstPath() == "edit") return null;
    if (context.user.registration_completed == "0")
      return <li className="breadcrumb-item">Step-I</li>;
    else if (context.user.marks_uploaded == "0")
      return <li className="breadcrumb-item">Step-II</li>;
    else if (context.user.certificates_uploaded == "0")
      return <li className="breadcrumb-item">Step-III</li>;
    else if (context.user.application_declaration == "0")
      return <li className="breadcrumb-item">Application Preview</li>;
    else if (
      context.user.regular_course_applied == "0" &&
      context.user.self_course_applied == "0"
    )
      return <li className="breadcrumb-item">Step-IV</li>;
  };

  const getUrl = () => {
    if (props.path == "/apply")
      return <li className="breadcrumb-item">Course Apply</li>;
    if (props.path == "/my-profile")
      return <li className="breadcrumb-item">My Profile</li>;
    if (props.path == "/edit/marks")
      return <li className="breadcrumb-item">Edit Step-II</li>;
    if (props.path == "/edit/personal")
      return <li className="breadcrumb-item">Edit Step-I</li>;
    if (props.path == "/edit/certificates")
      return <li className="breadcrumb-item">Edit Step-III</li>;
    if (firstPath() == "payment-status")
      return <li className="breadcrumb-item">Payment Status</li>;
  };

  const admissionImg = context.settingValue("admission_img_width");
  const supportPhone = context.settingValue("admission_support_mobile");
  const supportEmail = context.settingValue("admission_support_email");

  return (
    <header className="admission-header-modern">
      <div className="bg-secondary-theme py-1">
        <div className="container-fluid px-4 px-lg-5">
          <Row className="align-items-center">
            <Col md={6} className="d-none d-md-block">
              <span className="text-secondary-color fw-500 fs-11">
                <i className="fa-solid fa-graduation-cap me-1 opacity-75"></i>
                M.Phil Admission —{" "}
                {context.settingValue("current_academic_year")}
              </span>
            </Col>
            <Col md={6} className="text-end">
              <div className="d-flex align-items-center justify-content-end gap-3 fs-11 fw-700 text-secondary-color">
                {supportPhone && (
                  <span className="d-none d-md-inline">
                    <i className="fa-solid fa-phone me-1 opacity-50"></i>{" "}
                    {supportPhone}
                  </span>
                )}
                {supportEmail && (
                  <span className="d-none d-lg-inline">
                    <i className="fa-solid fa-envelope me-1 opacity-50"></i>{" "}
                    {supportEmail}
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="logo-area border-bottom">
        <div className="container-fluid px-4 px-lg-5">
          <Row className="align-items-center g-3">
            <Col md={6} sm={12} className="text-center text-md-start">
              <Link to="/" className="logo-link">
                <img
                  src={brandLogoWide()}
                  alt="Logo"
                  className="img-fluid"
                  style={{
                    width: "100%",
                    maxWidth:
                      admissionImg > 0
                        ? admissionImg + "px"
                        : S3_BUCKET_HOME_PATH == "sxctvl/"
                        ? "220px"
                        : "350px",
                    maxHeight:
                      S3_BUCKET_HOME_PATH == "sxctvl/" ? "55px" : "none",
                  }}
                />
              </Link>
            </Col>

            <Col md={6} sm={12} className="text-center text-md-end">
              <div className="d-flex align-items-center justify-content-center justify-content-md-end gap-3">
                <div className="text-start me-3 d-none d-lg-block">
                  <div className="fs-10 text-muted fw-800">SESSION STATUS</div>
                  <div className="fs-12 fw-bold text-success">
                    AUTHENTICATED{" "}
                    <i className="fa-solid fa-check-circle ms-1 text-success small"></i>
                  </div>
                </div>

                {(context.user.regular_course_applied == "1" ||
                  context.user.self_course_applied == "1") && (
                  <Link
                    to="/"
                    className="btn btn-outline-secondary btn-sm px-3 rounded-pill fs-12"
                  >
                    <i className="fa-solid fa-house me-1"></i>Dashboard
                  </Link>
                )}

                <button
                  type="button"
                  className="btn-signout-modern border-0 mt-0"
                  onClick={handleLogout}
                >
                  <i className="fa-solid fa-power-off me-2"></i>
                  <span>SIGN OUT</span>
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="admission-breadcrumb-strip py-2 d-none d-md-block">
        <div className="container-fluid px-4 px-lg-5">
          <Row className="align-items-center">
            <Col md={7}>
              <ol className="breadcrumb mb-0 bg-transparent p-0 fs-13 fw-600">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-secondary opacity-75">
                    <i className="fas fa-home me-1"></i> Admission Home
                  </Link>
                </li>
                {getStep()}
                {getUrl()}
              </ol>
            </Col>
            <Col md={5} className="text-end">
              <div className="fs-12 fw-800 text-dark opacity-75">
                <i className="fa-solid fa-circle-user me-2 opacity-50 text-primary"></i>
                WELCOME, {context.user.name && context.user.name.toUpperCase()}{" "}
                {context.user.initial}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </header>
  );
};

export default Header;
